import { useEffect } from "react";
import { SingleSelection } from "../SingleSelection.jsx";
import { useFormDispatch } from "../../FormContext.jsx";
import styles from "../../showroomForm.css";

const DispatchingSingleSelection = ({
  fieldKey,
  formData,
  required,
  setFormData,
  error,
  label,
  description,
  options,
  validate,
  edit,
}) => {
  const dispatch = useFormDispatch();

  const value = formData[fieldKey];

  useEffect(() => {
    if (error) return;
    dispatch({ type: "updateField", [fieldKey]: value });
  }, [value, error, dispatch, fieldKey]);

  return (
    <div className={styles.enhancedCompContainer}>
      <SingleSelection
        edit={edit}
        description={description}
        fieldKey={fieldKey}
        label={label}
        formData={formData}
        setFormData={setFormData}
        options={options}
        required={required}
        validate={validate}
        error={error}
      />
    </div>
  );
};

export default DispatchingSingleSelection;
